// extracted by mini-css-extract-plugin
module.exports = {"Buttons":"ResourceButtons_Buttons__18mND"};